// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const sceptile_mega: PokeData = {
  "id": 10065,
  "name": "sceptile-mega",
  "height": 19,
  "weight": 552,
  "base_experience": 284,
  "types": [
    PokeType.GRASS,
    PokeType.DRAGON
  ],
  "api_moves": [
    "pound",
    "slam",
    "leer",
    "absorb",
    "mega-drain",
    "agility",
    "quick-attack",
    "screech",
    "detect",
    "false-swipe",
    "fury-cutter",
    "pursuit",
    "leaf-blade",
    "night-slash",
    "x-scissor",
    "leaf-storm",
    "quick-guard",
    "dual-chop"
  ],
  "moves": [
    "leer",
    "quick-attack",
    "pursuit",
    "night-slash",
    "solar-beam",
    "outrage",
    "vine-whip",
    "draco-meteor",
    "dragon-vortex",
    "dragon-pulse",
    "great-roar",
    "dragon-breath",
    "energy-ball"
  ],
  "evolution_chain": {
    "id": 130,
    "item": null,
    "species": [
      {
        "name": "treecko",
        "order": 277,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "grovyle",
        "order": 278,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 252,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "sceptile",
        "order": 279,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 253,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 82,
    "speed": 159,
    "ability_power": 159
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
